import { useQuery } from 'react-query'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { getAllFunnelStages } from '../api'

export const useGetAllFunnelStagesForFilters = () => {
  const dispatch = useAppDispatch()
  const { data, ...rest } = useQuery(
    ['filters', 'shared', 'salesFunnelStatuses'],
    async () => {
      await dispatch(getAllFunnelStages())
    },
  )
  return rest
}
